import { Drawer, Grid, Stack } from "@mui/material";
import DrawerMenu from "./DrawerMenu";
import { Link } from "react-router-dom";
import Logo from "components/Logo";
import { getUserData } from "helpers";

type Props = {
  openDrawer: boolean;
  setOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>;
};

function HeaderDrawer({ openDrawer, setOpenDrawer }: Props) {
  const userData = getUserData();
  const { colors } = userData;

  return (
    <Drawer
      anchor={"left"}
      open={openDrawer}
      onClose={() => setOpenDrawer(false)}
      sx={{
        "& .MuiDrawer-paper": {
          width: "100%",
          maxWidth: "300px",
          padding: "20px",
          backgroundColor: colors?.menuBgColor
            ? colors?.menuBgColor
            : "#f9f9f9",
        },
      }}
    >
      <Stack borderRadius={4} my={1}>
        <Grid container justifyContent={"center"}>
          <Link to="/">
            <Logo />
          </Link>
        </Grid>

        <DrawerMenu setOpenDrawer={setOpenDrawer} />
      </Stack>
    </Drawer>
  );
}

export default HeaderDrawer;
